import React from 'react';
import PropTypes from 'prop-types';
import { showResponseTime, formatHoursAsDays } from '../../utils';
import './style.scss';

/**
 * @function
 * @name Stats
 * @param {Object} user - all the user data
 * @param {Boolean} allowEditing - whether the user can edit
 * Returns the markup of the seller stats
 */
const Stats = ({user, allowEditing, toggleVacation, isOnVacation}) => {
    const monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];

    const showCountry = user.country && user.country.length > 0,

        // showLastDelivery = parseInt(user.recent_delivery, 10) > 0, // this is the correct way
        showLastDelivery = user.recent_delivery && user.recent_delivery.length > 0, // this is getting the wrong value from v2
        memberSinceDate = new Date(user.member_since*1000),
        memberSince = `${monthNames[memberSinceDate.getMonth()]} ${memberSinceDate.getFullYear()}`;

    return (

        <ul className="user-stats">

            {showCountry &&
                <li className="location">
                    {i18n.t('seller_card.from')}
                    <strong>{user.country}</strong>
                </li>
            }

            <li className="member-since">
                {i18n.t('seller_card.member_since')}
                <strong>{memberSince}</strong>
            </li>

            {showResponseTime(user.response_time) &&
                <li className="response-time">
                    {i18n.t('seller_card.response_time')}
                    <strong>{formatHoursAsDays(user.response_time)}</strong>
                </li>
            }

            {showLastDelivery &&
                <li className="recent-delivery">
                    {i18n.t('seller_card.recent_delivery')}
                    <strong>{user.recent_delivery}</strong>
                </li>
            }

            {allowEditing &&
                <li className="vacation">
                    {i18n.t('seller_card.out_of_office')}
                    <div className="toggle-wrapper rf">
                        <label onClick={toggleVacation} className="toggle-vacation">
                            <input type="checkbox" value="vacation" className={isOnVacation ? 'sel' : ''} checked={isOnVacation}/>
                            <div className="fake-toggle"></div>
                        </label>
                    </div>
                </li>
            }
        </ul>
    );
};

Stats.propTypes = {
    user: PropTypes.object.isRequired,
    allowEditing: PropTypes.bool.isRequired
};

export default Stats;


// WEBPACK FOOTER //
// ./src/components/stats/index.js